import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Divider, Flex, List, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import type { ServiceInstanceDTO } from "api";

import BusinessServicesListItem, { BusinessServicesListItemSkeleton } from "../BusinessServicesListItem";
import { SearchInput } from "./BusinessServicesList.styles";

export interface BusinessServicesListProps {
  loading?: boolean;
  header?: boolean;
  services: ServiceInstanceDTO[];
}

const BusinessServicesList: React.FC<BusinessServicesListProps> = ({ services, header, loading }) => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState("");

  return (
    <Flex vertical>
      {header && (
        <>
          <Flex justify="space-between" align="flex-start">
            <Typography.Title level={3}>{t("business.details.services")}</Typography.Title>

            <SearchInput
              disabled={loading}
              size="large"
              placeholder={`${t("business.details.services.search")}...`}
              prefix={<SearchOutlined />}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </Flex>

          <Divider />
        </>
      )}

      {loading ? (
        <List
          itemLayout="horizontal"
          size="large"
          dataSource={Array.from({ length: 5 }, (_, index) => index)}
          renderItem={(index) => <BusinessServicesListItemSkeleton key={index} />}
        />
      ) : (
        <List
          itemLayout="horizontal"
          size="large"
          locale={{
            emptyText: t("business.details.services.empty"),
          }}
          dataSource={services.filter((service) => (service.customName || "").toLowerCase().includes(searchText))}
          renderItem={(service) => <BusinessServicesListItem key={service.id} service={service} />}
        />
      )}
    </Flex>
  );
};

export default BusinessServicesList;
